/**
 * Maps a `POST /pos-admin-grants/verify-admin` server error message to an
 * `adminAuth.err*` i18n key. Unknown/missing messages fall back to the generic
 * key (this includes `CONFLICT:INVALID_PERMISSION`, which can only arise from
 * a client bug and has no dedicated copy).
 */
export function mapGrantErrorToI18nKey(
  serverMessage: string | undefined
): string {
  switch (serverMessage) {
    case 'CONFLICT:INVALID_CODE':
      return 'adminAuth.errInvalidCode';
    case 'CONFLICT:EXPIRED':
      return 'adminAuth.errExpiredCode';
    case 'CONFLICT:USED':
      return 'adminAuth.errUsedCode';
    case 'CONFLICT:REVOKED':
      return 'adminAuth.errRevokedCode';
    case 'FORBIDDEN:INSUFFICIENT_PERMISSION':
      return 'adminAuth.errNoPermission';
    case 'FORBIDDEN:OUT_OF_SCOPE':
      return 'adminAuth.errOutOfScope';
    default:
      return 'adminAuth.errVerifyGeneric';
  }
}
